import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import { type UserForDetails } from '../AdminUserDetails.types';
import { USER_DETAILS_FIELDS } from '../constants';

type UsersResponse = { contents: { users: UserForDetails[] } };

export const adminUserDetailsApi = createApi('adminUserDetailsApi', {
    ...getBackRoyalApiBaseConfig('adminUserDetailsApi'),
    endpoints: builder => ({
        getUserForDetails: builder.query<UserForDetails, string>({
            query: userId => ({
                url: `users/${userId}`,
                params: { 'fields[]': USER_DETAILS_FIELDS },
            }),
            transformResponse: (response: UsersResponse) => response.contents.users?.[0],
        }),
    }),
});

// Each visit refetches the user, so edits made since the last visit show once it lands.
export const useUserForDetails = (userId: string) =>
    adminUserDetailsApi.useGetUserForDetailsQuery(userId, { refetchOnMountOrArgChange: true });
